import { render, staticRenderFns } from "./cModalAddUnit.vue?vue&type=template&id=c0b4b674"
import script from "./cModalAddUnit.vue?vue&type=script&lang=js"
export * from "./cModalAddUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports